import { useSelector } from 'react-redux'
import { PokerGameModel } from 'mvppoker-portal-common/api'
import { RootState } from '../AppStore'

export const usePublicActiveGame = () : PokerGameModel | undefined =>
{
	return useSelector((root: RootState) => root.publicUser.activeGame)
}

export const usePublicUserId = () : string =>
{
	return useSelector((root: RootState) => root.publicUser.userId)
}

export const usePublicRooms = () : PokerGameModel[] =>
{
	return useSelector((root: RootState) => root.publicUser.rooms)
}